/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const kindsOfDivorceSectionStyle = {
  container: {
    textAlign: "center",
  },
  header: {
    marginBottom: "30px",
  },
  text: {
    textAlign: "left",
  },
};

export default kindsOfDivorceSectionStyle;
